import React from "react";
import { Datacenter, datadogLogs } from "@datadog/browser-logs";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { hydrate } from "react-dom";
import { ValuationFunnelContainer } from "./containers/ValuationFunnelContainer/ValuationFunnelContainer";
import { TMarketingChrome } from "./components/Marketing/MarketingChrome/MarketingChrome";

declare const window: Window & {
    __FUNNEL__: { view: TMarketingChrome; initialPostcode: string; introducerId: string | null };
};

const render = (): void => {
    datadogLogs.init({
        clientToken: (env.REACT_APP_DATADOG_CLIENT_TOKEN || ""),
        forwardErrorsToLogs: true,
        datacenter: Datacenter.EU,
        sampleRate: 100,
    });

    hydrate(
        <ValuationFunnelContainer
            view={window.__FUNNEL__.view}
            initialPostcode={window.__FUNNEL__.initialPostcode}
            introducerId={window.__FUNNEL__.introducerId}
        />,
        document.getElementById("app"),
    );
};

render();
